/**
 * The decisions an employer record can be waiting on, read from fields the workspace already
 * loads. Kept apart from the component so the rules are testable without mounting a
 * thousand-line workspace.
 */

/**
 * The account is waiting for review. Absent is not pending: it means approved, matching
 * `EmployerApprovalStatus.isBlocking` on the backend, because every employer created before the
 * field carries null.
 */
export const reviewPending = (approvalStatus?: string | null): boolean =>
  (approvalStatus ?? '').trim().toUpperCase() === 'PENDING';

/**
 * The Premium Hiring contract step waiting on staff, or null when there is none.
 *
 * `send`: they asked, and no agreement has gone out. `activate`: it has been sent and signed
 * offline, and turning Premium Hiring on is what is left. An account that is already managed is
 * waiting on nothing, whatever the request field still says.
 */
export const pendingContractStep = (managed?: {
  isPremium?: boolean | null;
  premiumRequestStatus?: string | null;
} | null): 'send' | 'activate' | null => {
  if (!managed || managed.isPremium) return null;
  const s = (managed.premiumRequestStatus ?? '').trim().toUpperCase();
  if (s === 'PENDING') return 'send';
  if (s === 'CONTRACT_SENT') return 'activate';
  return null;
};
